import AllProjects from "./all-projects";
import MyProjects from "./my-projects";
import ProjectContainer from "./projectContainer";

export { AllProjects, MyProjects };

export default ProjectContainer;
